import { render, staticRenderFns } from "./B2BSection.vue?vue&type=template&id=3d3e8884&scoped=true"
import script from "./B2BSection.vue?vue&type=script&lang=js"
export * from "./B2BSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e8884",
  null
  
)

export default component.exports